import { useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { CashAdvancesCustomerSchemas, OffersSchemas } from "api-types";
import { useMemo } from "react";

import { useOfferRequestPath } from "../hooks/use-offer-request-path";
import { combineOfferAndCashAdvance } from "../utils/utils";

export const useDownloadOfferCollectionScheduleCsv = (
  offer: OffersSchemas.OfferDisplaySchema,
  cashAdvance?: CashAdvancesCustomerSchemas.CashAdvanceSummarySchema
) => {
  const client = useAxios();
  const requestPath = useOfferRequestPath().getCollectionScheduleCsv();
  const params = useMemo(() => combineOfferAndCashAdvance(offer, cashAdvance), [offer, cashAdvance]);

  return useQuery({
    queryKey: ["getOfferCollectionScheduleCsv", offer.id],
    queryFn: () =>
      client.post<Blob>(requestPath, params, {
        responseType: "blob",
        headers: {
          Accept: "text/csv",
        },
      }),
    select: ({ data }) => data,
    enabled: !!params && params.tranches.length > 0,
  });
};
